import React from 'react';
import { RelatedStories } from 'types';
import { DerivedReportSelector } from './DerivedReportSelector/DerivedReportSelector';
import { View } from 'common/types/view';

function EmbedTitle({ view, relatedStories }: { view: View; relatedStories?: RelatedStories }) {
  const hasSelectableReports =
    relatedStories && relatedStories.derivedStories.length + (relatedStories.defaultStory ? 1 : 0) > 1;

  if (hasSelectableReports) {
    return <DerivedReportSelector view={view} relatedStories={relatedStories} />;
  }

  return (
    <span className="asset-name forge-typography--subheading4" title={view.name}>
      {view.name}
    </span>
  );
}

export function EmbedHeader({ view, relatedStories }: { view: View; relatedStories?: RelatedStories }) {
  return (
    <div id="story-embed-header-bar">
      <span className="embed-header-item">
        <EmbedTitle view={view} relatedStories={relatedStories} />
      </span>
    </div>
  );
}
